import Indicator, { IndicatorType } from '../types/Indicator'

const AverageTrueRangeBands: Indicator = {
  type: IndicatorType.OVERLAY,
  value: 'averageTrueRangeBands',
  label: 'Average True Range Bands',
  nickname: 'ATR Bands',
  fields: ['upper', 'lower'],
  params: {
    field: 'close',
    period: 5,
    multiplier: 3,
  },
}

export default AverageTrueRangeBands
